import React, { createContext, useContext, useState, useEffect } from 'react';
import { publicAPI } from '../services/api';

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const res = await publicAPI.getData();
        if (!cancelled) setData(res.data);
      } catch (err) {
        console.error('Failed to fetch data from backend:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  const refresh = async () => {
    try {
      const res = await publicAPI.getData();
      setData(res.data);
    } catch { /* keep existing data */ }
  };

  return (
    <DataContext.Provider value={{ data, loading, refresh }}>
      {children}
    </DataContext.Provider>
  );
}

export function useData() {
  const ctx = useContext(DataContext);
  if (!ctx) throw new Error('useData must be used within DataProvider');
  return ctx;
}
